import script from "./OutlineDangerButton.vue?vue&type=script&setup=true&lang=js"
export * from "./OutlineDangerButton.vue?vue&type=script&setup=true&lang=js"

import "./OutlineDangerButton.vue?vue&type=style&index=0&id=8dd85d24&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8dd85d24"]])

export default __exports__